import { useCallback, useState } from "react"
import { Item } from "../../../../../utils/types/generals"
import { useInput } from "./useInput"
import { getPreviousYears, monthYear } from "../../../../../utils/constants/date_month"
import { getArea, getDepartments, getDivisions, getRoles, getUsers, getUserTypes } from "../../../../../utils/methods/geServiceWithItemsFormat"
import { Roles } from "../../../../../utils/enums"



const useGetData = () => {
  const [items, setItems] = useState<{ [x: string]: Item[] }>({})
  const { input } = useInput({ items })
  const [departments, setDepartments] = useState<any[]>([])

  const getData = useCallback(async () => {
    getRolesService()
    getUserTypesService()
    getDivisionsService()
    getUsersService()
    getAreasService()
    getDepartmentService()
    setItems((prev) => ({
      ...prev,
      createYear: getPreviousYears(),
      month: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
      })),
    }))

  }, [])

  const getRolesService = async () => {
    const responseRoles = await getRoles({ skip: [Roles.ADMIN] })

    setItems((prev) => ({
      ...prev,
      roles: responseRoles.items,
    }))
  }

  const getAreasService = async () => {
    const responseAreas = await getArea()

    setItems((prev) => ({
      ...prev,
      area: responseAreas,
    }))
  }

  const getDepartmentService = async () => {
    const departments = await getDepartments()
    setDepartments(departments)
  }


  const getUserTypesService = async () => {
    const { items } = await getUserTypes()

    setItems((prev) => ({
      ...prev,
      userTypeId: items,
    }))
  }

  const getUsersService = async () => {

    /* const role = getUserRole()
    if (role === Roles.AGENT) return */

    const { items } = await getUsers({ addUserLogged: true })

    setItems((prev) => ({
      ...prev,
      userId: items,
    }))
  }

  const getDivisionsService = async () => {
    const division = await getDivisions()

    setItems((prev) => ({
      ...prev,
      divisions: division.items,
    }))
  }

  const handleItemsByExternal = ({
    name,
    value,
  }: {
    name: string
    value: any
  }) => {
    setItems((prev) => ({
      ...prev,
      [name]: value,
    }))
  }


  return { input, getData, items, departments, handleItemsByExternal }
}

export { useGetData }
